import { useEffect } from 'react'; // useState

// project-imports
import Routes from 'routes';
import ThemeCustomization from 'themes';

// import Loader from 'components/Loader';
import Locales from 'components/Locales';
import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';
import Customization from 'components/Customization';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';
import WindowFocusHandler from 'contexts/WindowFocusHandler';

// import { dispatch } from 'store';
// import { fetchDashboard } from 'store/reducers/menu';

// auth-provider
// import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import { useSelector } from 'react-redux';
import { ContemporaryProvider } from 'contexts/ContemporaryContext';
import { ExamRecorderProvider } from 'contexts/ExamRecorder';
import { CanvasProvider } from 'contexts/CanvasContext';
// import useConfig from 'hooks/useConfig';
// import useAuth from 'hooks/useAuth';
// import { setThemeSetting } from 'store/reducers/certificate';
// import { setLogo, setSettings } from 'store/reducers/organizationSettings';
// import { dispatch } from 'store';
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';
// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const App = () => {
  // const [loading, setLoading] = useState<boolean>(false);
  const favIconPath = useSelector((state: any) => state?.organization?.favIcon?.[0]?.path);

  const defaultFavicon = '/vid_lms_logo_webicon.png';

  const favicon = favIconPath ? process.env.REACT_APP_FILE_URL + favIconPath : defaultFavicon;

  useEffect(() => {
    let link: any = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }

    link.href = favicon;
  }, [favicon]);

  // useEffect(() => {
  //   const apiURL = process.env.REACT_APP_SERVER_BASE_URL;
  //   const socketDomain = process.env.REACT_APP_SOCKET_DOMAIN;

  //   // Creating the CSP meta tag dynamically
  //   const cspMetaTag = document.createElement('meta');
  //   cspMetaTag.httpEquiv = 'Content-Security-Policy';
  //   cspMetaTag.content = `
  //     default-src 'self';
  //     script-src 'self' https://player.vdocipher.com;
  //     style-src 'self' https://fonts.googleapis.com 'unsafe-inline';
  //     font-src 'self' https://fonts.gstatic.com;
  //     connect-src 'self' ${apiURL} ws://${socketDomain};
  //     img-src 'self' data: ${apiURL};
  //     media-src 'self' ${apiURL};
  //     frame-src 'none';
  //   `;

  //   // Append the meta tag to the <head>
  //   document.head.appendChild(cspMetaTag);
  // }, [])

  // if (!loading) return <Loader />;

  return (
    <ThemeCustomization>
      <RTLLayout>
        <Locales>
          <ScrollTop>
            <ContemporaryProvider>
              <AuthProvider>
                <ExamRecorderProvider>
                  <CanvasProvider>
                    <>
                      <Notistack>
                        <Routes />
                        {/* <Customization /> */}
                        <Snackbar />
                        <WindowFocusHandler />
                      </Notistack>
                    </>
                  </CanvasProvider>
                </ExamRecorderProvider>
              </AuthProvider>
            </ContemporaryProvider>
          </ScrollTop>
        </Locales>
      </RTLLayout>
    </ThemeCustomization>
  );
};

export default App;
